"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnMouseOut = void 0;
const react_1 = require("react");
const useOLMap_1 = require("../openlayers/useOLMap");
function useOnMouseOut(onMouseOut) {
    const map = useOLMap_1.useOLMap();
    const onMouseOutRef = react_1.useRef(onMouseOut);
    react_1.useEffect(() => {
        onMouseOutRef.current = onMouseOut;
    }, [onMouseOut]);
    react_1.useEffect(() => {
        const onMouseOut = () => {
            onMouseOutRef.current();
        };
        map.getViewport().addEventListener('mouseout', onMouseOut);
        return () => map.getViewport().removeEventListener('mouseout', onMouseOut);
    }, [map]);
}
exports.useOnMouseOut = useOnMouseOut;
//# sourceMappingURL=useOnMouseOut.js.map